import { render, staticRenderFns } from "./SearchReportWizardModal.vue?vue&type=template&id=a6c365c8&scoped=true"
import script from "./SearchReportWizardModal.vue?vue&type=script&lang=ts"
export * from "./SearchReportWizardModal.vue?vue&type=script&lang=ts"
import style0 from "./SearchReportWizardModal.vue?vue&type=style&index=0&id=a6c365c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c365c8",
  null
  
)

export default component.exports